import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Simulateur from './components/Simulateur';

function App() {

  return (
    <BrowserRouter basename="/questionnaire-steps/">
      <Routes>
        <Route path="/" element={<Simulateur />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
